const philosophy = {
  // HeroSection
  'philosophy.hero.homeLink': 'ホーム',
  'philosophy.hero.aboutLink': 'アカデミーについて',
  'philosophy.hero.currentPage': '教育理念・方針',
  'philosophy.hero.title': '教育理念・方針',
  'philosophy.hero.titleEn': 'OUR PHILOSOPHY',
  'philosophy.hero.lead': '私たちは、技術の習得と人としての品格の涵養を両輪とする執事教育を掲げています。実践を重視する日本の執事学校として、おもてなしを支える執事養成に取り組んでいます。',
  'philosophy.hero.imgAlt': '白手袋でティーカップを扱う執事の手元',

  // PhilosophyStatement
  'philosophy.statement.label': 'PHILOSOPHY',
  'philosophy.statement.mainLine': '先回りの心を、確かな技術で支える。',
  'philosophy.statement.para1': 'おもてなしは、生まれ持った素質ではありません。観察し、準備し、所作として繰り返すことで、誰もが確かな技術として身につけられるものだと私たちは考えています。日本執事アカデミーの教育は、精神論や抽象的な「おもてなしの心」だけを語る場ではなく、その心を具体的な所作として再現できる力——つまり「型」を徹底的に訓練する場です。',
  'philosophy.statement.para2': 'しかし技術だけでは、真の執事にはなれません。相手の立場に立ち、口に出す前に必要を察し、秘密を守り抜く——こうした人格の土台があってこそ、所作は「かたち」から「もてなし」へと昇華します。私たちのすべての授業は、技術と人格が一体となった執事を育てるために設計されています。執事を体系的に学べる執事学校として、この考えを執事養成の全課程に貫いています。',
  'philosophy.statement.para3': 'この理念は本科課程だけのものではありません。法人研修で提供する接遇・ビジネスマナー指導にも、同じ思想が流れています。先を読む観察力、相手に合わせた距離感、信頼を損なわない所作——執事教育の本質は、あらゆるサービス業の現場で求められる力です。ただし法人研修では執事資格を付与するものではなく、接遇スキルとしてお伝えしています。',
  'philosophy.statement.sub1': '「型」を徹底的に訓練する',
  'philosophy.statement.sub2': '技術と人格を一体に育てる',
  'philosophy.statement.sub3': '法人研修にも通じる思想',
  'philosophy.statement.example': 'たとえば「先回りの心」を磨く授業では、講師が合図を出す前に受講生が動くロールプレイングを行います。ゲストの仕草や目線の動きを観察し、「次に何が必要か」を察知して自然に動く——この訓練を繰り返すことで、意識しなくても先回りできる身体をつくります。',

  // ThreePolicies
  'philosophy.policies.label': 'OUR APPROACH',
  'philosophy.policies.title': '3つの教育方針',
  'philosophy.policies.subtitleEn': 'Three Educational Principles',
  'philosophy.policies.lead': '理念を教室で実現するために、私たちは三つの方針を貫いています。授業のすべての場面に、この三つが息づいています。',
  'philosophy.policies.1.title': '実践に根ざした学び',
  'philosophy.policies.1.desc': '座学で終わらせず、必ず実技へと展開します。講義で「なぜその所作が必要か」を理解した後、実際に体を動かして型を覚え、最後にロールプレイングで実戦に近い状況下での応用力を養います。頭と身体の両方で覚えるからこそ、現場で即座に再現できる力になります。',
  'philosophy.policies.2.title': '少人数だからできる個別指導',
  'philosophy.policies.2.desc': '1クラス定員6名の完全少人数制。講師は受講生一人ひとりの所作を細部まで確認し、その場で修正します。立ち姿の重心、手の角度、目線の配り方——集団授業では見過ごされがちな微細な癖も、少人数だからこそ見逃さず、確実な習得へと導きます。',
  'philosophy.policies.3.title': '段階的に積み上げる体系',
  'philosophy.policies.3.desc': '基礎から管理・危機対応まで、3段階のコースで段階的に学びます。エッセンシャルで所作の基盤を固め、アドバンスで応用力を広げ、マスターで管理と判断力を磨く——どの段階からでも始められ、自分の目的に合わせて進める体系です。',

  // IdealButler
  'philosophy.ideal.label': 'OUR VISION',
  'philosophy.ideal.title': '育てたい執事像',
  'philosophy.ideal.subtitleEn': 'The Ideal Butler We Cultivate',
  'philosophy.ideal.lead': '私たちが目指すのは、技術と人格が一体となった執事です。確かな所作はもちろん、守秘を守り抜く誠実さ、状況に応じて判断する冷静さを併せ持つ人材を育てます。',
  'philosophy.ideal.1.title': '確かな技術',
  'philosophy.ideal.1.desc': 'ティーサービス、テーブルセッティング、クローク管理からVIP対応まで——執事に求められる一連の所作を、どのような場面でも破綻なく再現できる技術力を身につけます。',
  'philosophy.ideal.2.title': '品格と誠実さ',
  'philosophy.ideal.2.desc': '所作の美しさだけでなく、その所作を支える人格を重視します。相手を思いやる誠実さと、どんな状況でも冷静さを保つ品格——これらを授業のあらゆる場面で涵養します。',
  'philosophy.ideal.3.title': '守秘と信頼',
  'philosophy.ideal.3.desc': '執事の職業倫理の核心は、知り得た情報を厳守することです。授業では守秘義務の重要性を繰り返し説き、信頼を裏切らない職業人としての自覚を育みます。',
  'philosophy.ideal.4.title': '状況に応じた判断力',
  'philosophy.ideal.4.desc': 'マニュアル通りの対応ではなく、相手・場所・状況を瞬時に読み取り、最善の行動を選び取る判断力を磨きます。ロールプレイングで多数のケースを経験し、応用力を鍛えます。',

  // TeachingProcess
  'philosophy.process.label': 'HOW WE TEACH',
  'philosophy.process.title': '指導の進め方',
  'philosophy.process.subtitleEn': 'The Learning Cycle',
  'philosophy.process.lead': '学びは、聞いて終わりにはしません。講義で理解したことを実技で試し、ロールプレイングで磨き、講師のフィードバックで仕上げる——この循環を繰り返します。',
  'philosophy.process.step1.num': '01',
  'philosophy.process.step1.title': '講義',
  'philosophy.process.step1.desc': '「なぜその所作なのか」を理論から理解します。歴史的背景、おもてなしの原理、サービス哲学を学び、技術の土台となる知識を身につけます。',
  'philosophy.process.step2.num': '02',
  'philosophy.process.step2.title': '実技',
  'philosophy.process.step2.desc': '講義で学んだ内容を、実際に身体を動かして訓練します。講師の手本を見てから反復練習を行い、「わかる」から「できる」へと転換します。',
  'philosophy.process.step3.num': '03',
  'philosophy.process.step3.title': 'ロールプレイング',
  'philosophy.process.step3.desc': 'ゲスト役と執事役に分かれ、実戦に近い状況で対応力を磨きます。想定外の動きにも臨機応変に対応する力を、繰り返しの訓練で養います。',
  'philosophy.process.step4.num': '04',
  'philosophy.process.step4.title': 'フィードバック',
  'philosophy.process.step4.desc': '講師が一人ひとりの所作を細かく確認し、修正点と改善の方向を具体的に伝えます。この振り返りが、確実な成長のエンジンです。',
  'philosophy.process.certNote': '各コース修了時には実技試験を実施し、合格者には全日本執事協会認定のバトラー資格を授与します。',
  'philosophy.process.certLink': '修了証・認定資格について詳しく見る',

  // FAQ
  'philosophy.faq.label': 'FAQ',
  'philosophy.faq.title': 'よくあるご質問',
  'philosophy.faq.subtitleEn': 'Frequently Asked Questions',
  'philosophy.faq.footer': 'その他のご質問はお問い合わせフォームよりお寄せください',
  'philosophy.faq.q1': '精神論の研修ですか？',
  'philosophy.faq.a1': 'いいえ。おもてなしを訓練可能な技術として捉え、所作・サービス・対応力を実技中心に体系立てて指導します。',
  'philosophy.faq.q2': '少人数にこだわる理由は？',
  'philosophy.faq.a2': '一人ひとりの所作を細かく確認し、その場で修正するためです。定員6名の完全少人数制を採用しています。',
  'philosophy.faq.q3': '修了時に評価はありますか？',
  'philosophy.faq.a3': 'はい。各コース修了時に実技試験を行い、合格者には協会認定資格を授与します。詳しくは修了証・認定資格のページをご覧ください。',

  // CTA
  'philosophy.cta.label': 'TAKE THE NEXT STEP',
  'philosophy.cta.title': 'まずはお気軽にどうぞ',
  'philosophy.cta.body': 'コース詳細や受講の流れについて、ご不明な点がございましたらお気軽にお問い合わせください。',
  'philosophy.cta.note': '※ご相談はオンラインでも承ります',
  'philosophy.cta.courses': 'コースを見る',
  'philosophy.cta.consultation': '個別相談を予約する',

  // RelatedPages
  'philosophy.related.title': '関連ページ',
  'philosophy.related.subtitleEn': 'Explore Further',
  'philosophy.related.viewLink': '詳しく見る',
  'philosophy.related.backLink': 'アカデミーについての総合ページへ戻る',
  'philosophy.related.link0.title': '全日本執事協会について',
  'philosophy.related.link0.desc': '運営母体と提供する事業のご紹介',
  'philosophy.related.link1.title': 'コース一覧・比較',
  'philosophy.related.link1.desc': '3つのコースの違いを一覧で確認',
  'philosophy.related.link2.title': 'カリキュラム概要',
  'philosophy.related.link2.desc': '学びの全体像と進め方',
  'philosophy.related.link3.title': '修了証・認定資格について',
  'philosophy.related.link3.desc': '修了で得られる協会認定資格',
  'philosophy.related.link4.title': 'アカデミーについて',
  'philosophy.related.link4.desc': 'アカデミーの全体像',

  // Last updated
  'philosophy.lastUpdated': '最終更新: 2026年7月8日',
};

export default philosophy;
